import { IFeature, IFile, IImage, ISEO, IVideo } from 'app/interfaces/common';
import { getFileUrl } from 'app/utility/directus';

export function mapFileFields(item: Directus.File | null): IFile | null {
  if (!item) return null;
  return {
    ...item,
    url: getFileUrl(item.id, item.modified_on)
  };
}

export function mapImageFields(item?: Directus.Image | null): IImage | null {
  if (!item) return null;
  return {
    ...item,
    alt: item.description || item.title,
    url: getFileUrl(item.id, item.modified_on)
  };
}

export function mapVideoFields(item?: Directus.Video | null): IVideo | null {
  if (!item) return null;
  return {
    ...item,
    file: mapFileFields(item.file),
    image: mapImageFields(item.image)
  };
}

export function mapSEOFields(item?: Directus.SEO | null): ISEO | null {
  if (!item) return null;
  return {
    ...item,
    og_image: mapImageFields(item.og_image),
    keywords: item.keywords ?? null
  };
}

export function mapFeatureFields(item: Directus.Feature): IFeature {
  return {
    ...item,
    image: mapImageFields(item.image)
  };
}
